import script from "./Transaction.vue?vue&type=script&setup=true&lang=js"
export * from "./Transaction.vue?vue&type=script&setup=true&lang=js"

import "./Transaction.vue?vue&type=style&index=0&id=0559fc30&lang=scss"
import "./Transaction.vue?vue&type=style&index=1&id=0559fc30&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0559fc30"]])

export default __exports__